import React from "react";
import './addon-price.scss';
import {AddonStore} from "../../../../stores/addons-store-list";
import FontHeading4 from "../../../../../../../components/fonts/font-heading4/font-heading4";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../../../components/fonts/font-props";
import FontBody2 from "../../../../../../../components/fonts/font-body2/font-body2";

const AddonPrice: React.FC<{ addon: AddonStore, addonName: string }> = ({addon, addonName}) => {

    return (
        <div className="addon-price-quota-based-price">
            {
                addon.isQuotaBased() ?
                    <div className="manage-addons-quota-based-price">
                        {addon.currentUserQuota > 0 &&
                            <div>
                                <FontHeading4 variant={FONT_VARIANT.BOLD}>
                                    ${addon.originalPrice}
                                </FontHeading4>
                                <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                                    &nbsp;/&nbsp; {addon.paymentType}
                                </FontBody2>
                            </div>
                        }
                        <div>
                            <FontBody2 color={FONT_COLOR.ACCENT1} variant={FONT_VARIANT.BOLD}>
                                ${addon.featurePrice}
                            </FontBody2>
                            <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                                &nbsp;/&nbsp;{addonName}&nbsp;per month
                            </FontBody2>
                        </div>
                    </div>
                    :
                    <div className="manage-addons-center-items">
                        <FontHeading4 variant={FONT_VARIANT.BOLD}>
                            ${addon.addonPrice}
                        </FontHeading4>
                        <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                            &nbsp;/&nbsp;{addon.paymentType}
                        </FontBody2>
                    </div>
            }
        </div>
    );
};

export default AddonPrice;